import React, { lazy } from 'react'
import { App } from '@reactiveonline/frontend_shared_components'
import HeaderIcons from './header/HeaderIcons'

export default function AppLayout(props) {
  let PageContent = null
  if (!props.packageComponent) {
    PageContent = lazy( () => import(`./${ props.componentPath }`) )
  }

  return (
    <App
      { ...props }
      PageContent={ PageContent }
      appProps={{
        ...props.appProps,
        HeaderIcons: HeaderIcons
      }}
    />
  )
}
